import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingModal from '@ublique/components/Modal'
import DataTable from '@ublique/components/DataTable'
import TableActions from '@ublique/components/DataTable/components/TableActions'
import { useAgGridTranslation } from 'utils/hooks/useDocumentTranslation'
import './index.scss'
import {
  filtering,
  pagination,
  styling,
  defaultColumnDefs,
  getTablecActions,
  getColumnDefs
} from './table'
import { synapse } from '@ublique/platform'
import { BASE_URL } from 'config'
// import body from './mock.json'
import { keys } from 'lodash'

function WarningScenarioModal({ open, close, data }) {
  const [gridApi, setGridApi] = useState()
  const [tableData, setTableData] = useState()
  const [noStandardColumns, setNoStandardColumns] = useState([])
  const { t } = useTranslation(['Scenario', 'Document', 'Shell'])
  const { t: agGridT } = useAgGridTranslation()
  const { scenario } = data
  const { id } = scenario

  const fetchScenarioWarningData = async function (hideOverlay = false) {
    const url = `${BASE_URL}/scenarioflow/warning/${id}`
    // const url = `${BASE_URL}/scenarios`
    const response = await synapse.fetch(url)
    const { body } = response

    const additionalColumns = []

    const warningData = body.map((row) => {
      additionalColumns.push(...keys(row.customPropsList))
      return { ...row, ...row.customPropsList }
    })

    setNoStandardColumns([...new Set(additionalColumns)])

    setTableData(warningData)

    if (hideOverlay) {
      gridApi.api.hideOverlay()
    }
  }

  useEffect(() => {
    fetchScenarioWarningData()
  }, [])

  const refreshButtonAction = () => {
    gridApi.api.showLoadingOverlay()
    fetchScenarioWarningData(true)
  }

  const exportCsvButtonAction = () => {
    gridApi.api.exportDataAsCsv({
      fileName: `${t('Scenario.ScenarioWarning.WARNING_MODAL_TITLE')}.csv`
    })
  }

  return (
    <LoadingModal
      loading
      passiveModal
      size='lg'
      className='warning-scenario-modal'
      open={open}
      onRequestClose={close}
      modalHeading={t('Scenario.ScenarioWarning.WARNING_MODAL_TITLE')}
    >
      <div className='table-warning'>
        <DataTable
          onGridReady={(params) => {
            setGridApi(params)
          }}
          {...filtering}
          {...styling}
          {...pagination}
          columnDefs={getColumnDefs(t, noStandardColumns)}
          defaultColDef={defaultColumnDefs}
          rowData={tableData}
          className='warning-scenario-table'
          extraHeaderComponent={
            <TableActions
              t={agGridT}
              config={getTablecActions({
                t,
                refreshButtonAction,
                exportCsvButtonAction
              })}
            />
          }
        />
      </div>
    </LoadingModal>
  )
}

export default WarningScenarioModal
